















































































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import SortDrawer from '~/components/SortDrawer.vue';
import BottomDrawerDialog from '~/components/UIComponents/BottomDrawerDialog.vue';
import { ISortOption } from '~/store/types';

@Component({ components: { SortDrawer, BottomDrawerDialog } })
export default class StoreFilterControls extends Vue {
  @Prop(String) readonly value!: string;
  @Prop(Array) readonly sortOptions!: ISortOption[];
  @Prop(Array) readonly currencyOptions!: ISortOption[];
  @Prop(Object) readonly selectedSort!: ISortOption;
  @Prop(Object) readonly selectedCurrency!: ISortOption;

  showSortDrawer = false;
  showSortDropDown = false;
  showCurrencyDrawer = false;
  showCurrencyDropDown = false;

  get mobileView() {
    return this.$vuetify.breakpoint.smAndDown;
  }

  toggleSortOptions() {
    if (this.mobileView) {
      this.showSortDrawer = !this.showSortDrawer;
    } else {
      this.showSortDropDown = !this.showSortDropDown;
    }
  }

  toggleCurrencyOptions() {
    if (this.mobileView) {
      this.showCurrencyDrawer = !this.showCurrencyDrawer;
    } else {
      this.showCurrencyDropDown = !this.showCurrencyDropDown;
    }
  }

  getCurrencyTitle(slug: string) {
    const id = `components.store.storeFilterControls.${slug}`;
    const title = this.$t(id);
    return id === title
      ? this.$t('components.store.storeFilterControls.currencyValue', {
          selectedCurrency: slug,
        })
      : title;
  }

  @Emit('currency-selected')
  handleCurrencySelected(currency: ISortOption) {
    setTimeout(() => {
      this.showCurrencyDrawer = false;
      this.showCurrencyDropDown = false;
    }, 300);
    return currency;
  }
  @Emit('sort-selected')
  handleSortSelected(sortOption: ISortOption) {
    setTimeout(() => {
      this.showSortDrawer = false;
      this.showSortDropDown = false;
    }, 300);
    return sortOption;
  }
}
